export class ClassSorter {
  static sort(list: any, property: string, reverse = false): void {
    list.sort((a: any, b: any) => {
      let valueA = a[property];
      let valueB = b[property];

      if (valueA < valueB) {
        return reverse ? 1 : -1;
      }
      if (valueA > valueB) {
        return reverse ? -1 : 1;
      }
      return 0;
    });
  }
}
